import axios from "axios";
import { env } from "../../env";

const API_RESOURCES = env.REACT_APP_HMW_API_HOST_NAME;

export const CreditCardConfig = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios.get(
        `${API_RESOURCES}/CreditCardConfig.json`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": "true",
          },
        }
      );
      console.log("Resp", resp.data);
      resolve(resp.data);
      return resp.data;
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
